import { useState, useMemo } from 'react';
import {
  AGENT_LIST_DOCUMENT,
  ALL_STATUS_OPTIONS,
  BUSINESS_TYPE_OPTIONS,
  isOlderThanMinutes,
} from '../utils';

type SortOrder = 'asc' | 'desc';

export const useDocumentsTaskFilters = (data: any[], country: string) => {
  const [filters, setFilters] = useState<{
    agent: string[];
    action: string[];
    business_type: string[];
  }>({
    agent: [],
    action: ['pending', 'progress'],
    business_type: ['real_estate', 'committee'],
  });

  const [sortOrder, setSortOrder] = useState<SortOrder>('asc');

  const handleFilterChange = (
    key: 'agent' | 'action' | 'business_type',
    selected: string[]
  ) => {
    setFilters(prev => ({ ...prev, [key]: selected }));
  };

  const toggleSortOrder = () => {
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const filteredData = useMemo(() => {
    const filtered = data.filter(row => {
      const matchAgent =
        filters.agent.length === 0 ||
        filters.agent.includes(row.agent || 'Sin asignar');
      const matchAction =
        filters.action.length === 0 || filters.action.includes(row.action);
      const matchBusinessType =
        filters.business_type.length === 0 ||
        filters.business_type.includes(row.business_type);
      const matchDate = isOlderThanMinutes(row.date, 1);
      return matchAgent && matchAction && matchBusinessType && matchDate;
    });

    return [...filtered].sort((a, b) => {
      const aTime = new Date(a.date).getTime();
      const bTime = new Date(b.date).getTime();
      return sortOrder === 'asc' ? aTime - bTime : bTime - aTime;
    });
  }, [data, filters, sortOrder]);

  const agentOptions = useMemo(() => {
    const agents = AGENT_LIST_DOCUMENT[country] || [];
    return agents.map(agent => ({ label: agent, value: agent }));
  }, [country]);

  const actionOptions = ALL_STATUS_OPTIONS;

  const businessTypeOptions = BUSINESS_TYPE_OPTIONS;

  return {
    filters,
    filteredData,
    agentOptions,
    actionOptions,
    businessTypeOptions,
    sortOrder,
    handleFilterChange,
    toggleSortOrder,
  };
};
